import { DEFAULT_LOCALE, FLYSITE_HELP_URL, FLYSITE_URL } from 'constants/index';
import { cmsLocales, extractLocaleCode } from 'utils/translations';

const CONTACT_PATH = 'contact';
const SUPPORT_PATH = 'support';
const PRIVACY_PATH = 'privacy';
const TERMS_PATH = 'terms';
const BEST_PRICE_GUARANTEE_PATH = 'best-price-guarantee';
const COOKIE_POLICY = 'cookie-policy';
const RECURRING_TERMS_PATH = 'legal/automated-payments-terms-of-use';

const getFlysitePathUrl = (path: string, locale = DEFAULT_LOCALE) => {
  return `${getFlysiteUrl(locale)}/${path}/`;
};

const getFlysiteUrl = (locale = DEFAULT_LOCALE) => {
  const localeCode = extractLocaleCode(locale).toLowerCase();
  const supportedCmsLocale = cmsLocales.find(
    cmsLocale => localeCode === extractLocaleCode(cmsLocale).toLowerCase(),
  );

  const localePath =
    localeCode === DEFAULT_LOCALE || !supportedCmsLocale
      ? ''
      : `/${localeCode}`;

  return `${FLYSITE_URL}${localePath}`;
};

export const helpUrl = (locale = DEFAULT_LOCALE) => {
  const localeCode = extractLocaleCode(locale).toLowerCase();
  const supportedCmsLocale = cmsLocales.find(
    cmsLocale => localeCode === extractLocaleCode(cmsLocale).toLowerCase(),
  );
  const localePath =
    localeCode === DEFAULT_LOCALE || !supportedCmsLocale
      ? '/en-us'
      : `/${localeCode}`;

  return `${FLYSITE_HELP_URL}/hc${localePath}`;
};

export const flysiteUrl = (locale: string) => getFlysiteUrl(locale);
export const contactUrl = (locale: string) =>
  getFlysitePathUrl(CONTACT_PATH, locale);
export const supportUrl = (locale: string) =>
  getFlysitePathUrl(SUPPORT_PATH, locale);
export const privacyUrl = (locale: string) =>
  getFlysitePathUrl(PRIVACY_PATH, locale);
export const termsUrl = (locale: string) =>
  getFlysitePathUrl(TERMS_PATH, locale);
export const bestPriceGuaranteeUrl = (locale: string) =>
  getFlysitePathUrl(BEST_PRICE_GUARANTEE_PATH, locale);
export const cookiePolicyUrl = (locale: string) =>
  getFlysitePathUrl(COOKIE_POLICY, locale);
export const recurringTermsUrl = (locale: string) =>
  getFlysitePathUrl(RECURRING_TERMS_PATH, locale);
